"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
var CheckmarkSize;
(function (CheckmarkSize) {
    CheckmarkSize[CheckmarkSize["Large"] = 0] = "Large";
    CheckmarkSize[CheckmarkSize["Small"] = 1] = "Small";
})(CheckmarkSize || (CheckmarkSize = {}));
const NotificationCheckmark = (0, react_1.memo)(({ selected = false, size = CheckmarkSize.Small, className, hasSelected, isPortableDevice = false, }) => {
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "$hasSelected": hasSelected, "data-e2e": 'Container', children: hasSelected && !isPortableDevice && ((0, jsx_runtime_1.jsx)(ui_1.Checkmark, { checked: selected, size: size, "data-e2e": 'Checkmark' })) }));
});
const Container = styled_components_1.default.div `
  display: none;
  justify-content: center;
  align-items: center;
  margin-right: 15px;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    padding-left: 28px;
    display: flex;
    margin-right: 15px;
    justify-content: center;
    align-items: center;
    width: 20px;
  `)};
`;
exports.default = NotificationCheckmark;
